module.exports = __webpack_public_path__ + "img/on.a6b8fc03.svg";